import firebase from 'firebase/app';
import 'firebase/firestore';

export default {
  namespaced: true,

  state: {
      loading:false,
  },

  getters: {
    loading: (state) => state.loading,
  },

  mutations: {
    CREATE_STARTED(state){
      console.log('load');
        state.loading=true
    },
    CREATE_FINISHED(state){
      console.log('finish');
      state.loading=false
  }
},

  actions: {

    async doSubmitContactForm ({ commit }, data) {
        commit('CREATE_STARTED')
        var id = firebase
          .firestore()
          .collection('ids')
          .doc().id;
        console.log(commit);
        console.log(data);
        var obj = {
          id: id,
          firstName: data.firstName,
          lastName: data.lastName,
          email: data.email,
          phoneNumber: data.phoneNumber,
          company: data.company,
          message: data.message,
          createdAt: firebase.firestore.Timestamp.now(),
        };
        await firebase
          .firestore()
          .collection('contactUs')
          .doc(id)
          .set({
            ...obj,
          });
        if (data.language == 'ar') {
          firebase
            .firestore()
            .collection('mail')
            .doc(id)
            .set({
              to: data.email,
              template: {
                name: 'contactEmailToClient-ar',
              },
            });
        } else {
          firebase
            .firestore()
            .collection('mail')
            .doc(id)
            .set({
              to: data.email,
              template: {
                name: 'contactEmailToClient',
              },
            });
        }

        id = firebase
          .firestore()
          .collection('ids')
          .doc().id;
          console.log(data);
        firebase
          .firestore()
          .collection('mail')
          .doc(id)
          .set({
            to: 'chairman@afigr.com',
            // message:{
            //   html: "you contacted us",
            //   subject: "Contact email"
            // }
            template: {
              name: 'contactEmailToCompany',
              data: {
                name: data.firstName + " " + data.lastName,
                phoneNumber: data.phoneNumber,
                email: data.email,
                company: data.company,
                message: data.message,
              },
            }
          });

        commit('CREATE_FINISHED')
      },
    
  },
};
